import { Pipe, PipeTransform } from '@angular/core';

import { UtilitiesService } from '../services/utilities/utilities.service';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  constructor(private utilsService: UtilitiesService) { }

  transform(arreglo: any[], texto: string, columna: string): any[] {
    if (texto.toString() === '') {
      return arreglo
    }

    return arreglo.filter(item => this.utilsService.normalizeText(item[columna])
      .includes(this.utilsService.normalizeText(texto))
    );

  }

}
